import React from "react";
import {Box, Grid, Link, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Analytics from "../../libs/analytics";
import SimpleBar from "simplebar-react";
import Dotdotdot from "react-dotdotdot";
import common from "../../utils/common";

const isString = value => typeof value === "string";
const formatPrice = (price) => {
    if(price && isString(price)){
        if(price.indexOf("$") >= 0){
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toFixed(2);
            return price.replace(onlyPrice, formattedPrice);
        }else{
            const onlyPrice = clearPrice(price);
            const formattedPrice = Number(onlyPrice).toFixed(2);
            return "$" + price.replace(onlyPrice, formattedPrice);
        }
    }else if (typeof price === "number"){
        return "$"+Number(price).toFixed(2);
    }else{
        return price
    }
}
const clearPrice = value => isString(value) ? value.replace(/[^\d.]/g, '') : value;
const RenderPrice = (entity) => {
    const product = entity.data && typeof entity.data === 'object' ? {...entity, ...entity.data} : entity;
    if (product.price && product.price_sale) {
        const onlyPrice = Number(clearPrice(product.price));
        const onlyPriceSale = Number(clearPrice(product.price_sale));
        if (onlyPriceSale < onlyPrice){
            return <span>
                <span style={{color: "#D00000"}}>{formatPrice(product.price_sale)}</span> <strike style={{color: "#2b2b2b"}}
                className={"old-price"}>{formatPrice(product.price)}</strike></span>;
        }
    }
    return formatPrice(product.price)
}

const ProductsHorizontal = ({ ambassador, products }) => {


    const sendPKevent = (e, product) =>{
        const {asset} = window.TVSite.channelVideosData;
        Analytics.productClick(product, asset.id);
        return e;
    }

    return <Box px={2}>
        <Box pt={2}>
            <Box>
                <SimpleBar style={{overflowY: "hidden"}}>
                    <Box display="flex" width={"100%"}>
                        <Grid container spacing={1} flexDirection={'row'} flexWrap={'nowrap'}>
                            {
                                products.map((product, index) => {
                                    const {data:{imageUrl, linkUrl}} = product;
                                    return <Grid item xs={6} key={product.product_id} sx={{minWidth: "50%"}} >
                                        <Link color="inherit" href={common.addSharedIdToUrl(linkUrl, ambassador?.user_id, product.product_id)} onClick={(e) => sendPKevent(e, product)}
                                            target={"_blank"}
                                            sx={{
                                                textDecoration: "none !important",
                                                "&:hover, &:focus": {
                                                    textDecoration: "none !important"
                                                }
                                            }}>
                                        <Box paddingTop={'133.8%'} width={'100%'} position={'relative'} bgcolor={"#f8f8f8"}
                                             display={'flex'} justifyContent={'center'}>
                                            <img src={imageUrl} alt={product.title} height={'100%'}
                                                 style={{position: 'absolute', top: 0}}/>
                                        </Box>
                                        <Box py={1}>
                                            <Typography component={"div"} fontSize={"14px"}>
                                                <Dotdotdot clamp={1}>
                                                    {product.title}
                                                </Dotdotdot>
                                            </Typography>
                                        </Box>
                                        <Box pb={1}>
                                            <Typography fontSize={"14px"}>
                                                {RenderPrice(product)}
                                            </Typography>
                                        </Box>
                                        </Link>
                                    </Grid>
                                })
                            }
                        </Grid>
                    </Box>
                </SimpleBar>
            </Box>

        </Box>
        <Box pt={4} pb={1}>

        </Box>
    </Box>
}

ProductsHorizontal.propTypes = {
    ambassador: PropTypes.object,
    products: PropTypes.array.isRequired
}
ProductsHorizontal.defaultProps = {
    products: []
};

export default ProductsHorizontal;